export default __webpack_public_path__ + "static/media/check-single-green.840dee69.svg";